/**
 * Modal for tournament admin to resolve conflicts: server was updated after client's last cache.
 * Options: Use server version (discard local) or Overwrite with my version (backend force).
 */

import React from 'react';
import './ConflictResolutionModal.css';

export default function ConflictResolutionModal({ conflict, onResolve, onClose, overwriteInProgress }) {
  if (!conflict) return null;
  const { serverMatch } = conflict;
  const serverTime = serverMatch?.updatedAt ? new Date(serverMatch.updatedAt).toLocaleString() : '';
  const busy = overwriteInProgress === true;

  return (
    <div className="conflict-modal-overlay" onClick={onClose}>
      <div className="conflict-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="conflict-modal-title">Update conflict</h2>
        <p className="conflict-modal-desc">
          This match was updated on the server after your last load. Choose which version to keep.
        </p>
        {serverTime && (
          <p className="conflict-modal-meta">Server last updated: {serverTime}</p>
        )}
        <div className="conflict-modal-actions">
          <button
            type="button"
            className="btn-primary"
            onClick={() => onResolve(conflict, 'useServer')}
            disabled={busy}
          >
            Use server version
          </button>
          <button
            type="button"
            className="btn-secondary"
            onClick={() => onResolve(conflict, 'overwrite')}
            disabled={busy}
          >
            {busy ? 'Applying…' : 'Overwrite with my version'}
          </button>
          <button type="button" className="btn-secondary" onClick={onClose} disabled={busy}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
